import type { SVGProps } from 'react';

export const CaretDownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9999 19.3331C11.7439 19.3331 11.4879 19.2358 11.2932 19.0398L2.95992 10.7065C2.56926 10.3158 2.56926 9.68251 2.95992 9.29184C3.35059 8.90117 3.98392 8.90117 4.37459 9.29184L12.0012 16.9185L19.6279 9.29184C20.0185 8.90117 20.6519 8.90117 21.0425 9.29184C21.4332 9.68251 21.4332 10.3158 21.0425 10.7065L12.7092 19.0398C12.5146 19.2345 12.2586 19.3331 12.0026 19.3331H11.9999Z"
      fill="currentColor"
    />
  </svg>
);
